
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div>
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


    <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
      <div class="row">
        <!--<div class="col-md-1 padding-left-0px padding-right-0px">
          <a class="education-navlink addicon-circle">
            <span class="badge">

              <i class="fas fa-user-plus"></i>
            </span>
          </a>
        </div>-->
        <div class="col-md-4 padding-left-9px padding-right-0px">
          <label class="margin-top-3px">Storage Bank</label>
        </div>

        <div class="col-md-8">
          <button type="button" class="close float-right margin-top-4px" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!--<div class="col-md-8 float-right" *ngIf="CurrentCounsellingPlanController.length==0">
          <div class="row">
            <div class="col-md-8">
              <label class="margin-top-3px"> Add Proposed Plan</label>
            </div>
            <div class="col-md-4">
              <button type="button" class="close" data-dismiss="modal"
                      (click)="activeModal.dismiss('Cross click')"
                      aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>

        </div>
        <div class="col-md-8 float-right" *ngIf="CurrentCounsellingPlanController.length>0">
          <div class="row">
            <div class="col-md-8">
              <label class="margin-top-3px"> Counselling Plan (Active)</label>
            </div>
            <div class="col-md-4">
              <button type="button" class="close" data-dismiss="modal"
                      (click)="activeModal.dismiss('Cross click')"
                      aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>

        </div>-->
      </div>



    </div>

    <div class="modal-body padding-top-0px counselling-modal">

      <div class="row">
        <div class="col-md-3 bk-color-light2">
          <div class="row margin-top-10">
            <div class="col-md-12">
              <div class=" card card-background-transparent card-height">
                <div class="row margin-top-10">
                  <div class="col-md-11 text-align-center padding-left-0px" *ngIf="SelectedTreatmentCycle">
                    <img class="img-circle-50 margin-left-10px" [src]="SelectedTreatmentCycle.OwnerPatientImageFile" onError="this.src='dummy.jpg';">

                  </div>
                </div>
                <div class="row">
                  <div class="col-md-11 padding-left-0px padding-right-0px text-align-center" *ngIf="SelectedTreatmentCycle">
                    <label class="margin-bottom-0px color5 font-weight-bold font-size-19px margin-bottom-0px">{{SelectedTreatmentCycle.OwnerName}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-11 padding-left-0px padding-right-0px text-align-center" *ngIf="SelectedTreatmentCycle">
                    <label class="margin-bottom-0px">{{SelectedTreatmentCycle.OwnerFormattedCode}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 padding-left-0px padding-right-0px text-align-center margin-left-3px" *ngIf="SelectedTreatmentCycle">



                    <div [ngSwitch]="SelectedTreatmentCycle.OwnerGender">
                      <div *ngSwitchCase="'F'" class="font-size-12px">

                        {{SelectedTreatmentCycle.OwnerAgeYears}},Female
                      </div>
                      <div *ngSwitchCase="'M'" class="font-size-12px">

                        {{SelectedTreatmentCycle.OwnerAgeYears}},Male
                      </div>


                      <div *ngSwitchCase="'O'" class="td-brorder-8px-blue font-size-12px">
                        {{SelectedTreatmentCycle.OwnerAgeYears}},Other
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">

                  <div class="col-md-11 padding-left-0px padding-right-0px text-align-center margin-left-3px" *ngIf="SelectedTreatmentCycle">
                    {{SelectedTreatmentCycle.OwnerTelephone1}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class=" col-md-9 padding-left-0px">
          <div class="accordion margin-bottom-20px margin-top-10" id="accordionExample5" *ngIf="GradingModel=='Well Culture'">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                        Egg
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-8 ">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" hidden>Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                  <!--<div class="col-md-6">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                    <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                  </div>-->
                </div>


              </div>

              <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                  <div class="card margin-bottom-0px">
                    <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                      <div class="row">
                        <div class="col-md-3">
                          <label class="font-weight-normal font-size-14">Add/Edit</label>
                        </div>
                        <div class="col-md-3 text-align-right">
                          <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                          <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                        </div>
                      </div>

                    </div>-->
                    <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">
                      <div class="row">
                        <div class="col-md-12 padding-right-0px">
                          <div class="table-component">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero width-100pe">

                                <thead class="">
                                  <tr>
                                    <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Date</th>


                                    <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Well#</th>

                                    <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Morphology</th>
                                    <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary padding-left-0px">Storage</th>
                                    <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Details</th>
                                    <th class="padding-top-4px padding-bottom-4px padding-right-0px font-weight-normal background-primary padding-left-0px">Status</th>

                                  </tr>
                                </thead>
                                <tbody class="table-body">
                                  <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                  <!--</ng-container>-->
                                  <tr *ngFor="let l of EggList">

                                    <td>{{l.LastUpdateDate| date:'MMM-dd-yyyy'}}</td>

                                    <td class="padding-right-0px padding-top-0px padding-bottom-0px">{{l.WellNo}}</td>

                                    <td class="padding-top-0px padding-bottom-0px">{{l.Morphology}}</td>

                                    <td class="padding-all-0px">

                                      <!--<CodeTypeValue CodeType="OST" [(ngModel)]="l.StorageUnitType" SelectedValue="l.StorageUnitType"
                                      required></CodeTypeValue>-->
                                      {{l.StorageUnitType}}
                                    </td>
                                    <td class="padding-top-0px padding-bottom-0px">
                                      <!--<input type="text" class="form-control" min="1" max="10" placeholder="Details"
                                             id="l.StorageUnitDetails"
                                             [(ngModel)]="l.StorageUnitDetails"
                                             name="l.StorageUnitDetails" #Remarks="ngModel"
                                             maxlength="100">
                                      <small class="form-text text-danger"
                                             *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>-->
                                      {{l.StorageUnitDetails}}
                                    </td>
                                    <td class="padding-top-0px padding-bottom-0px  padding-left-0px">
                                      <a class="color-datacolor font-weight-normal text-decoration font-size-14">
                                        <i class="fas fa-circle color-Assign nav-link-hand  ">
                                        </i>
                                      </a>
                                    </td>
                                    <!--<td class="padding-all-0px">
                                      <button type="submit" (click)="onSubmit2(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l?.IsSelected"><i class="far fa-save"></i></button>


                                    </td>-->



                                  </tr>
                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion margin-bottom-20px" id="accordionExampleTwosperm" *ngIf="GradingModel=='Well Culture'">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwosperm">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwosperm" aria-expanded="true" aria-controls="collapseTwosperm">
                        Sperm
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-8 ">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" hidden>Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                  <!--<div class="col-md-6">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                    <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                  </div>-->
                </div>


              </div>

              <div id="collapseTwosperm" class="collapse show" aria-labelledby="headingTwosperm" data-parent="#accordionExampleTwosperm">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                  <div class="card margin-bottom-0px">
                    <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                      <div class="row">
                        <div class="col-md-3">
                          <label class="font-weight-normal font-size-14">Add/Edit</label>
                        </div>
                        <div class="col-md-3 text-align-right">
                          <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                          <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                        </div>
                      </div>

                    </div>-->
                    <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">
                      <div class="table-component">
                        <div class="table-responsive">


                          <table class="table table-striped margin-left-zero width-50-new">
                            <thead class="">
                              <tr>
                                <th class="font-weight-normal td-padding-tb background-primary padding-top-4px padding-bottom-4px">Date</th>
                                <th class="font-weight-normal td-padding-tb background-primary padding-top-4px padding-bottom-4px">
                                  Storage Type
                                </th>
                                <!--<th class="text-align-center">Day</th>-->
                                <th class="font-weight-normal td-padding-tb background-primary padding-top-4px padding-bottom-4px">
                                  Volume
                                </th>


                                <th class="font-weight-normal td-padding-tb background-primary padding-top-4px padding-bottom-4px">
                                  Storage Unit Details
                                </th>












                              </tr>
                            </thead>
                            <tbody class="table-body">
                              <tr *ngFor="let l of CurrentIvfSpermStoreByCodeController">
                                <td>{{l.LastUpdateDate| date:'MMM-dd-yyyy'}}</td>
                                <td class="padding-top-0px padding-bottom-0px">
                                  {{l.StorageUnitType}}
                                </td>
                                <td class="padding-top-0px padding-bottom-0px">
                                  {{l.Volume}}{{l.VolumeUnits}}
                                </td>
                                <td class="padding-top-0px padding-bottom-0px">{{l.StorageUnitDetails}}</td>
                              </tr>

                            </tbody>

                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion" id="accordionExample2embryo" *ngIf="GradingModel=='Well Culture'">

            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwoembryo">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwoembryo" aria-expanded="true" aria-controls="collapseTwoembryo">
                        Embryo
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-8">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>

                  </div>
                  <!--<div class="col-md-6">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                    <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                  </div>-->
                </div>


              </div>

              <div id="collapseTwoembryo" class="collapse show" aria-labelledby="headingTwoembryo" data-parent="#accordionExample2embryo">
                <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                  <div class="card margin-bottom-0px margin-top-10">

                    <div class="card-body padding-top-0px padding-bottom-0px padding-left-6px padding-right-0px margin-left-0px">

                      <div class="row">
                        <div class="col-md-12 ">
                          <div class="table-component">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero">

                                <thead class="">
                                  <tr>

                                    <th class="font-weight-normal td-padding-tb background-primary padding-top-4px padding-bottom-4px ">Date</th>

                                    <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Well#</th>

                                    <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Grade</th>
                                    <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary padding-left-0px">Storage</th>
                                    <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Details</th>
                                    <th class="padding-top-4px padding-bottom-4px padding-right-0px font-weight-normal background-primary">Status</th>

                                  </tr>
                                </thead>
                                <tbody class="table-body">
                                  <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                  <!--</ng-container>-->
                                  <tr *ngFor="let l of EmbryoList">

                                    <td>{{l.LastUpdateDate| date:'MMM-dd-yyyy'}}</td>

                                    <td class="padding-top-0px padding-bottom-0px">{{l.WellNo}}</td>

                                    <td class="padding-top-0px padding-bottom-0px">{{l.Grade}}</td>

                                    <td class="padding-all-0px">
                                      <!--<CodeTypeValue CodeType="OST" [(ngModel)]="l.StorageUnitType" SelectedValue="l.StorageUnitType"
                                      required></CodeTypeValue>-->
                                      {{l.StorageUnitType}}
                                    </td>
                                    <td class="padding-top-0px padding-bottom-0px">
                                      <!--<input type="text" class="form-control" min="1" max="10" placeholder="Details"
                                             id="l.StorageUnitDetails"
                                             [(ngModel)]="l.StorageUnitDetails"
                                             name="l.StorageUnitDetails" #Remarks="ngModel"
                                             maxlength="100">
                                      <small class="form-text text-danger"
                                             *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>-->
                                      {{l.StorageUnitDetails}}
                                    </td>
                                    <td class="padding-top-0px padding-bottom-0px">
                                      <a class="color-datacolor font-weight-normal text-decoration font-size-14">
                                        <i class="fas fa-circle color-Assign nav-link-hand  ">
                                        </i>
                                      </a>
                                    </td>




                                  </tr>
                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <!--<div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="card margin-bottom-0px background-lightpink">

                    <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                      <div class="table-component margin-bottom-0px padding-all-3px" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                        <div class="table-responsive">


                          <table class="table table-striped margin-left-zero">

                            <thead class="">
                              <tr>
                                <th class=" td-width-107px">Ov.Position</th>
                                <th class="padding-left-5px width-70px">Count</th>
                                <th class="padding-left-5px width-70px">Size</th>
                                <th>Comments</th>

                              </tr>
                            </thead>
                            <tbody class="table-body">

                              <tr>

                                <td>
                                  <CodeTypeValue CodeType="OVPS"
                                                 id="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos"
                                                 [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" SelectedValue=""
                                                 name="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" required>

                                  </CodeTypeValue>
                                </td>

                                <td class="td-padding ">

                                  <input type="number" class="form-control"
                                         min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                         [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                         name="CurrentSaveFollicularScanOvaryDetailRequest.Count" #Count="ngModel"
                                         maxlength="100">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                                </td>
                                <td class="td-padding ">
                                  <input type="text" class="form-control"
                                         min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                         [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                         name="CurrentSaveFollicularScanOvaryDetailRequest.Size" #Size="ngModel"
                                         maxlength="100">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                                </td>

                                <td class="td-padding ">
                                  <input type="text" class="form-control"
                                         min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                         [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                         name="CurrentSaveFollicularScanOvaryDetailRequest.Remarks" #Remarks="ngModel"
                                         maxlength="100">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                                </td>



                              </tr>

                            </tbody>

                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>-->
              </div>
            </div>


          </div>
          <div class="accordion" id="accordionExample2embryo" *ngIf="GradingModel=='Droplet Culture'">

            <div class="card margin-bottom-5px margin-top-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwoembryo">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwoembryo" aria-expanded="true" aria-controls="collapseTwoembryo">
                        Embryo
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-8">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>

                  </div>
                  <!--<div class="col-md-6">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                    <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                  </div>-->
                </div>


              </div>

              <div id="collapseTwoembryo" class="collapse show" aria-labelledby="headingTwoembryo" data-parent="#accordionExample2embryo">
                <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                  <div class="card margin-bottom-0px">

                    <div class="card-body padding-top-0px padding-bottom-0px padding-left-6px padding-right-0px margin-left-0px">
                      <div class="row">
                        <div class="form-group col-md-12 margin-bottom-5px padding-left-0px">
                          <div class="row">
                            <div class="col-md-4 padding-right-0px margin-top-5px text-align-right padding-left-0px">
                              <label class="margin-bottom-0px">
                                Select Straw Number :
                              </label>
                            </div>
                            <div class="col-md-3 padding-right-0px padding-left-0px">
                              <CodeTypeValue CodeType="STNO" id="StrawNumber"
                                             [(ngModel)]="StrawNumber" SelectedValue=""
                                             (keyChange)="dataChanged(StrawNumber)"
                                             name="StrawNumber" required>



                              </CodeTypeValue>

                            </div>
                          </div>

                        </div>

                      </div>
                      <div class="row">
                        <div class="col-md-12 ">
                          <div class="table-component">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero width-100pe">

                                <thead class="">
                                  <tr>
                                    <!--<th class="min-width-0px padding-right-0px padding-left-0px"></th>-->
                                    <th class="padding-top-4px padding-bottom-4px font-size-12px min-width-0px">Cycle#</th>
                                    <!--<th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Cycle Details </th>-->
                                    <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px">DOC</th>

                                    <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px padding-right-0px">Date</th>
                                    <!--<th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Straw#</th>-->
                                    <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Grade</th>
                                    <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px padding-left-9px">Stage</th>




                                    <!--<th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                                    <!--<th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->




                                  </tr>
                                </thead>
                                <tbody class="table-body">

                                  <tr *ngFor="let l of CurrentIvfCycleEmbryoTransferrablesControllerByActor ; let RowIndex = index ">

                                    <!--<td class="padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"> <input type="checkbox" class="width-15px "></td>-->
                                    <td class="padding-top-4px padding-bottom-4px text-align-center">{{l.CycleNo}}</td>
                                    <!--<td class="padding-top-4px padding-bottom-4px"></td>-->
                                    <td class="padding-top-4px padding-bottom-4px  padding-left-0px text-align-center">
                                      {{l.DOC}}

                                    </td>
                                    <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px">

                                      {{l.CreatedTimeStamp| date:'MMM-dd-yyyy'}}
                                    </td>
                                    <!--<td class="padding-top-4px padding-bottom-4px text-align-center"> {{l.StrawNumber}}</td>-->
                                    <td class="padding-top-4px padding-bottom-4px"><label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="l.DOC!=='4'">{{l.Grade2}} </label></td>

                                    <td class="padding-top-4px padding-bottom-4px">{{l.CellStage}}</td>


                                    <!--<td class="padding-top-4px padding-bottom-4px text-align-center">{{l.AvailableCount}}</td>-->

                                  </tr>
                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <!--<div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="card margin-bottom-0px background-lightpink">

                    <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                      <div class="table-component margin-bottom-0px padding-all-3px" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                        <div class="table-responsive">


                          <table class="table table-striped margin-left-zero">

                            <thead class="">
                              <tr>
                                <th class=" td-width-107px">Ov.Position</th>
                                <th class="padding-left-5px width-70px">Count</th>
                                <th class="padding-left-5px width-70px">Size</th>
                                <th>Comments</th>

                              </tr>
                            </thead>
                            <tbody class="table-body">

                              <tr>

                                <td>
                                  <CodeTypeValue CodeType="OVPS"
                                                 id="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos"
                                                 [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" SelectedValue=""
                                                 name="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" required>

                                  </CodeTypeValue>
                                </td>

                                <td class="td-padding ">

                                  <input type="number" class="form-control"
                                         min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                         [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                         name="CurrentSaveFollicularScanOvaryDetailRequest.Count" #Count="ngModel"
                                         maxlength="100">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                                </td>
                                <td class="td-padding ">
                                  <input type="text" class="form-control"
                                         min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                         [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                         name="CurrentSaveFollicularScanOvaryDetailRequest.Size" #Size="ngModel"
                                         maxlength="100">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                                </td>

                                <td class="td-padding ">
                                  <input type="text" class="form-control"
                                         min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                         [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                         name="CurrentSaveFollicularScanOvaryDetailRequest.Remarks" #Remarks="ngModel"
                                         maxlength="100">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                                </td>



                              </tr>

                            </tbody>

                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>-->
              </div>
            </div>


          </div>
        </div>
      </div>



    </div>
    <!--<div class="modal-footer padding-top-10px padding-bottom-10px">

      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>
      <button type="submit" class="btn font-size-13px actions-btn-prime">Save</button>
    </div>-->

  </div>
</div>
